import { applyStoragesMapFilters } from '@/articles/v4/storages_map';
import { isMobile } from '@/helpers/mobile_detect';
import asyncSweetScroll from '@/helpers/sweet_scroll';
import onIntersectionObserve from '@/helpers/on_intersection_observe';
import { CITY_LANDING_PAGE_IDS } from '@/pages/city_landing/page_ids';

let storagesSwiper = null;

pageUnload(...CITY_LANDING_PAGE_IDS, () => {
  if (storagesSwiper) {
    storagesSwiper.destroy();
    storagesSwiper = null;
  }
});

pageLoad(...CITY_LANDING_PAGE_IDS, () => {
  $('article.v4.storages .to-storage').on('click', ({ currentTarget }) => {
    const presetDefaultParams = $('#storages_app').data('preset_default_params') || {};

    applyStoragesMapFilters({
      ...presetDefaultParams,
      storageId: currentTarget.getAttribute('data-storage_id')
    });
    asyncSweetScroll('article.v4.storages_map');
  });

  const storagesNode = document.querySelector('article.v4.storages .swiper-v8');
  const isCarousel = Boolean(document.querySelector('article.v4.storages.is-carousel'));
  if (storagesNode && (isMobile() || isCarousel)) {
    onIntersectionObserve(storagesNode, initStoragesSwiper);
  }
});

async function initStoragesSwiper(node) {
  const [{ default: Swiper }, { Navigation, Pagination }] = await Promise.all([
    import('swiper'),
    import('swiper/modules')
  ]);

  storagesSwiper = new Swiper(node, {
    grabCursor: true,
    wrapperClass: 'cards',
    slideClass: 'card',
    slidesPerView: 1,
    breakpoints: { 1024: { slidesPerView: 2, spaceBetween: 24 } },
    modules: [Navigation, Pagination],
    pagination: {
      el: node.querySelector('.b-slider-pagination-v4'),
      bulletClass: 'bullet',
      bulletActiveClass: 'is-active',
      clickable: true
    },
    navigation: {
      nextEl: node.querySelector('.next'),
      prevEl: node.querySelector('.prev'),
      disabledClass: 'is-disabled'
    }
  });
  storagesSwiper.changeLanguageDirection(document.documentElement.getAttribute('dir'));
}
